import { PatchPartElementDto } from "../../interfaces/request.interface";

export namespace PartElementsActions {
    
  export class UpdatePartElements {
    static readonly type = '[Part Elements] Update Part Elements';
      partKey: any;
      elements!: PatchPartElementDto[];
    constructor(public payload:{ partKey: string; elements: PatchPartElementDto[] }) {}
  }
}